// extracted by mini-css-extract-plugin
export default {"basic":"Button_basic__KgEuj","label":"Button_label__Iq4rS","gap":"Button_gap__8siXV"};